import { render, staticRenderFns } from "./RoleFilters.vue?vue&type=template&id=6056b6ea&"
import script from "./RoleFilters.vue?vue&type=script&lang=js&"
export * from "./RoleFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports